import { Store } from "vuex";
import { store } from "@/shared-store";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";

export const isRequestAlreadyDone = (url: string): boolean => {
  const vuexStore = store as unknown as Store<IVuexState>;
  const uniqueRequestList: string[] =
    vuexStore.state.carts.uniqueRequestList || [];
  if (uniqueRequestList.includes(url)) {
    return true;
  } else {
    uniqueRequestList.push(url);
    vuexStore.dispatch("carts/setUniqueRequests", uniqueRequestList);
    sessionStorage.setItem(
      "uniqueRequestList",
      JSON.stringify(uniqueRequestList)
    );
    return false;
  }
};
